import React from 'react'
import ModalBasic from '../../component/ModalBasic'
import TextInput from '../../../components/UIComponent/TextInput'
import MultiSelectDropdown from '../../../components/dropdown/MultiSelectDropdown'
import { AgGridReact } from "ag-grid-react";

export const itemColdefs = [
    {
        field: "itemDetails",
        headerName: "Item Details",
        minWidth: window.innerWidth * 0.15,
        flex: 1.5,
        filter: true,
    },
    {
        field: "quantity",
        headerName: "Quantity",
        minWidth: window.innerWidth * 0.05,
        flex: 0.5,
        filter: true,
    },
    {
        field: "rate",
        headerName: "Rate",
        minWidth: window.innerWidth * 0.06,
        flex: 0.6,
        filter: true,
    },
    {
        field: "amount",
        headerName: "Amount",
        minWidth: window.innerWidth * 0.06,
        flex: 0.6,
        filter: true,
    },
    {
        field: "remarks",
        headerName: "Remarks",
        minWidth: window.innerWidth * 0.1,
        flex: 1,
        filter: true,
    },

];

export const MaterialOutPopup = (props) => {
    return (
        <ModalBasic
            id="material-out"
            classParams="!w-[75%] overflow-y-auto"
            modalOpen={props.isModalOpen}
            setModalOpen={props.setOpenModel}
        >
            <div className='input-fields p-[30px]'>
                <span className="text-blue text-[16px] font-semibold">Material out details</span>
                <div className='item-grp grid grid-cols-4 gap-2.5 mt-3 mb-2 pb-[8px] border-b border-slate-200 items-start'>
                    <div className='input-grp'>
                        <label>Challan no</label>
                        <TextInput type='text'
                            id='challanNo' name='challanNo'
                            value={props.materialObject.challanNo}
                            handleChange={(event) => props.handleChangeForMaterial(event, 'challanNo')}
                            className={props.validState?.error?.challanNo !== undefined ? "error" : ""}
                            disabled
                        />
                    </div>
                    <div className='input-grp'>
                        <label>Date</label>
                        <TextInput type='date'
                            id='challanDate' name='challanDate'
                            value={props.materialObject.challanDate}
                            handleChange={(event) => props.handleChangeForMaterial(event, 'challanDate')}
                            className={props.validState?.error?.challanDate !== undefined ? "error" : ""}
                        />
                    </div>
                    <div className='input-grp'>
                        <label>Supplier's ref.</label>
                        <TextInput type='text'
                            id='referenceNo' name='referenceNo'
                            value={props.materialObject.referenceNo}
                            handleChange={(event) => props.handleChangeForMaterial(event, 'referenceNo')}
                            className={props.validState?.error?.referenceNo !== undefined ? "error" : ""}
                        />
                    </div>
                    <div className='input-grp'>
                        <label>Other references</label>
                        <TextInput type='text'
                            id='otherReferences' name='otherReferences'
                            value={props.materialObject.otherReferences}
                            handleChange={(event) => props.handleChangeForMaterial(event, 'otherReferences')}
                            className={props.validState?.error?.otherReferences !== undefined ? "error" : ""}
                        />
                    </div>
                    <div className='input-grp col-span-2'>
                        <label>Supplier</label>
                        <MultiSelectDropdown
                            drpIdentity="Select accHead"
                            options={props.partyAccountList}
                            value={props.materialObject.iDVendor ? props.partyAccountList.find(x => x.value === props.materialObject.iDVendor) : 0}
                            onChange={(event) =>
                                props.setFilterParameters(event, "iDVendor")
                            }
                            className={props.validState?.error?.iDVendor !== undefined ? "error" : ""}
                        />

                    </div>
                    <div className='input-grp'>
                        <label>Order/Challan no</label>
                        <TextInput type='text'
                            id='orderNo' name='orderNo'
                            value={props.materialObject.orderNo}
                            handleChange={(event) => props.handleChangeForMaterial(event, 'orderNo')}
                            className={props.validState?.error?.orderNo !== undefined ? "error" : ""}
                        />
                    </div>
                    <div className='input-grp'>
                        <label>Order/Challan date</label>
                        <TextInput type='date'
                            id='orderDate' name='orderDate'
                            value={props.materialObject.orderDate}
                            handleChange={(event) => props.handleChangeForMaterial(event, 'orderDate')}
                            className={props.validState?.error?.orderDate !== undefined ? "error" : ""}
                        />
                    </div>
                    <div className='item-inner grid grid-cols-4 items-start gap-2.5 col-span-4'>
                        <div className='input-grp col-span-2 row-span-2'>
                            <label>Address</label>
                            <textarea rows={4}
                                id='address' name='address'
                                value={props.materialObject.address}
                                onChange={(event) => props.handleChangeForMaterial(event, 'address')}
                                className={`h-full ${props.validState?.error?.address !== undefined ? "error" : ""}`}
                            />
                        </div>
                        <div className='input-grp'>
                            <label>Dispatch doc. no</label>
                            <TextInput type='text'
                                id='documentNo' name='documentNo'
                                value={props.materialObject.documentNo}
                                handleChange={(event) => props.handleChangeForMaterial(event, 'documentNo')}
                                className={props.validState?.error?.documentNo !== undefined ? "error" : ""}
                            />
                        </div>
                        <div className='input-grp'>
                            <label>Dispatch doc. date</label>
                            <TextInput type='date'
                                id='documentDate' name='documentDate'
                                value={props.materialObject.documentDate}
                                handleChange={(event) => props.handleChangeForMaterial(event, 'documentDate')}
                                className={props.validState?.error?.documentDate !== undefined ? "error" : ""}
                            />
                        </div>
                        <div className='input-grp col-span-2'>
                            <label>Dispatch through</label>
                            <TextInput type='text'
                                id='dispatchThrough' name='dispatchThrough'
                                value={props.materialObject.dispatchThrough}
                                handleChange={(event) => props.handleChangeForMaterial(event, 'dispatchThrough')}
                                className={props.validState?.error?.dispatchThrough !== undefined ? "error" : ""}
                            />
                        </div>
                    </div>
                </div>
                <span className="text-blue text-[16px] font-semibold">Item details</span>
                <div className='item-grp grid grid-cols-4 gap-2.5 mt-3 mb-3'>
                    <div className='input-grp col-span-2'>
                        <label>Item details</label>
                        <TextInput type='text'
                            id='itemDetails' name='itemDetails'
                            value={props.itemObject.itemDetails}
                            handleChange={(event) => props.handleChangeForItem(event, 'itemDetails')}
                            className={props.validState?.error?.itemDetails !== undefined ? "error" : ""}
                        />

                    </div>
                    <div className='input-grp'>
                        <label>Quantity</label>
                        <TextInput type='number'
                            id='quantity' name='quantity'
                            value={props.itemObject.quantity}
                            handleChange={(event) => props.handleChangeForItem(event, 'quantity')}
                            className={props.validState?.error?.quantity !== undefined ? "error" : ""}
                        />

                    </div>

                    <div className='input-grp'>
                        <label>Rate</label>
                        <TextInput type='number'
                            id='rate' name='rate'
                            value={props.itemObject.rate}
                            handleChange={(event) => props.handleChangeForItem(event, 'rate')}
                            className={props.validState?.error?.rate !== undefined ? "error" : ""}
                        />
                    </div>

                    <div className='input-grp'>
                        <label>Amount</label>
                        <TextInput type='number'
                            id='amount' name='amount'
                            value={props.itemObject.amount}
                            handleChange={(event) => props.handleChangeForItem(event, 'amount')}
                            disabled
                        />
                    </div>

                    <div className="input-grp col-span-2">
                        <label>Remarks</label>
                        <TextInput type="text"
                            id="remarks" name="remarks"
                            value={props.itemObject.remarks}
                            handleChange={(event) => props.handleChangeForItem(event, "remarks")}
                            className={props.validState?.error?.remarks !== undefined ? "error" : ""}
                        />
                    </div>

                    <div className='btn-grp flex gap-2.5 mt-5'>
                        {/* {props.itemObject.keyId > 0 ?
                            <button className="save-btn btns py-[10px] px-[20px] h-[40px]" onClick={() => props.insert("Update")}>Update</button>
                            :
                            <button className="save-btn btns py-[10px] px-[20px] h-[40px]" onClick={() => props.insert("Insert")}>Insert</button>
                        }

                        <button className="delete-btn btns py-[10px] px-[20px] h-[40px]" onClick={() => props.clear()}>Delete</button> */}

                        {props.itemObject && props.itemObject.index === null ?
                            <div className="input-grp">
                                <button className="save-btn btns mt-auto mb-[2px]" onClick={() => props.insertItem("Insert")}> Insert</button>
                            </div>
                            :
                            <div className="input-grp flex items-center gap-2.5">
                                <button className="save-btn btns mt-auto mb-[2px]" onClick={() => props.insertItem("Update")}> Update</button>
                                <button className="delete-btn btns mt-auto mb-[2px]" onClick={() => props.deleteItem()}> Delete</button>
                            </div>
                        }
                    </div>
                </div>
                <div className="process-table h-[30vh]">
                    <div className="table-inner h-full">
                        <AgGridReact
                            rowData={props.itemRowData}
                            columnDefs={itemColdefs}
                            onCellClicked={props.handleCellClickItemList}
                            onGridReady={props.onGridReady}
                            overlayLoadingTemplate={'<span class="ag-overlay-loading-center">Loading data...</span>'}
                            overlayNoRowsTemplate="<span'>No Rows To Show</span>"
                        />
                    </div>
                </div>
                <div className='btn-grp flex gap-2.5 mt-5'>
                    <button className="update-btn btns" onClick={() => props.submit()}>Save</button>
                    <button className="delete-btn btns" onClick={() => props.close()}>Cancel</button>
                </div>
            </div>

        </ModalBasic>
    )
}